import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Store from './store'
import Search from './Search'
import EditView from './EditView'

import './style.scss'

@observer
class FeatureFlags extends Component {
    constructor(props) {
        super(props)
        this.store = new Store(props.appStore)
    }

    componentDidMount() {
        this.store.init()
    }

    render() {
        const { store } = this

        return (
            <div id="featureFlags" cssClass="feature-flags">
                {store.view === 'index' ? <Search store={store} /> : <EditView store={store} />}
            </div>
        )
    }
}

export default FeatureFlags
